import React from 'react';
type Bullet = string | {
  text: string;
  sub?: string[];
};
/** Split a "Tech Stack: a – b – c" line into a label + chips for richer display. */
function parseStack(text: string): {
  label: string;
  items: string[];
} | null {
  const m = text.match(/^(Tech Stack|Tech stack|Deployment|Tech stack:)\s*:?\s*(.+)$/);
  if (!m) return null;
  const label = m[1].replace(/:$/, '');
  const items = m[2].split(/[–\-,]/).map(s => s.trim()).filter(Boolean);
  if (items.length < 2) return null;
  return {
    label,
    items
  };
}
export function Bullets({
  items
}: {
  items: Bullet[];
}) {
  return <ul className="space-y-2" data-id="element-44" data-mp="1o15blssupiwy">
      {items.map((item, i) => {
      const text = typeof item === 'string' ? item : item.text;
      const sub = typeof item === 'string' ? undefined : item.sub;
      const stack = parseStack(text);
      if (stack) {
        return <li key={i} className="break-inside-avoid pt-1" data-id="element-45" data-mp="3me5m0h4n10xg">
              <span className="mr-2 font-mono text-[9.5px] uppercase tracking-[0.18em] text-[var(--ink-faint)]" data-id="element-46" data-mp="wai6q2dse0u">
                {stack.label}
              </span>
              <span className="inline-flex flex-wrap gap-1.5 align-middle" data-id="element-47" data-mp="3s2lds6omgmks">
                {stack.items.map((it, j) => <span key={j} className="rounded-sm border border-[var(--line-strong)] bg-white/50 px-1.5 py-[1px] font-mono text-[10px] text-[var(--ink-soft)]" data-id="element-48" data-mp="5naepu7l8u2t" data-mpi={j}>
                    {it}
                  </span>)}
              </span>
            </li>;
      }
      return <li key={i} className="break-inside-avoid text-[12px] leading-relaxed text-[var(--ink-soft)]" data-id="element-49" data-mp="3o2uq4bue6mkh" data-mpi={i}>
            <div className="flex gap-2.5" data-id="element-50" data-mp="13b12b2gxnbkn">
              <span className="mt-[9px] h-px w-2.5 shrink-0 bg-[var(--accent)]" aria-hidden="true" data-id="element-51" data-mp="139pvets6xnpb" />
              <span className="min-w-0 flex-1" data-id="element-52" data-mp="15f624t2xbzs7">{text}</span>
            </div>
            {sub && <ul className="mt-1.5 space-y-1 pl-[20px]" data-id="element-53" data-mp="1ae8w9ihd8lle">
                {sub.map((s, j) => <li key={j} className="flex gap-2.5 text-[12px] leading-relaxed text-[var(--ink-soft)]" data-id="element-54" data-mp="1fdc1p419cttw" data-mpi={j}>
                    <span className="mt-[8px] h-[3px] w-[3px] shrink-0 rounded-full bg-[var(--accent)]" aria-hidden="true" data-id="element-55" data-mp="1kbncbgzdn8d6" />
                    <span className="min-w-0 flex-1" data-id="element-56" data-mp="ro9b36onbqn9">{s}</span>
                  </li>)}
              </ul>}
          </li>;
    })}
    </ul>;
}